import React from "react";
import OpenPositions from "./OpenPositions";
class Projects extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <OpenPositions />
      </div>
    );
  }
}

export default Projects;



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/careers/index.js